import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrev = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 12,
	viewBox: "0 0 11 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M1 0C1.55228 0 2 0.44772 2 1V11C2 11.5523 1.55228 12 1 12C0.44772 12 0 11.5523 0 11V1C0 0.44772 0.44772 0 1 0ZM3.07869 6.4085C3.03208 6.3756 2.99144 6.3349 2.95854 6.2883C2.7993 6.0627 2.85309 5.7508 3.07869 5.5915L10.2117 0.55648C10.296 0.49693 10.3967 0.46496 10.5 0.46496C10.7761 0.46496 11 0.68882 11 0.96496V11.035C11 11.1383 10.968 11.239 10.9085 11.3234C10.7492 11.549 10.4373 11.6028 10.2117 11.4435L3.07869 6.4085Z"
	})
});
export default SvgPrev;
